import type { ReactNode } from "react";
import { useServerError } from "@/hooks/useServerError";
import ServerError from "./ServerError";

interface ServerErrorBoundaryProps {
  children: ReactNode;
}

/**
 * ServerErrorBoundary - Displays the ServerError page when a 5xx error is detected
 * This component checks the ServerErrorContext for any server errors and renders
 * the error page instead of the children when an error is present.
 */
export default function ServerErrorBoundary({ children }: ServerErrorBoundaryProps) {
  const { serverError, clearServerError } = useServerError();

  if (serverError) {
    return <ServerError error={serverError} resetError={clearServerError} />;
  }

  return <>{children}</>;
}